import {
  getBuildBranch,
  getBuildCommit,
  getBuildTime,
} from '../config/runtimeConfig';

export const getBuildInfo = () => ({
  commit: getBuildCommit(),
  branch: getBuildBranch(),
  buildTime: getBuildTime(),
});

/** @deprecated Use `getBuildInfo()` — this snapshot misses runtime overrides. */
export const BUILD_INFO = getBuildInfo();
